import { render } from "./callFollowUpReport.vue?vue&type=template&id=0c7648a6&scoped=true"
import script from "./callFollowUpReport.vue?vue&type=script&lang=js"
export * from "./callFollowUpReport.vue?vue&type=script&lang=js"

import "./callFollowUpReport.vue?vue&type=style&index=0&id=0c7648a6&scoped=true&lang=css"

import exportComponent from "/Users/habeebrahman/Documents/htdocs/cdz_projects/wg-frontend-v1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c7648a6"]])

export default __exports__